<template>
  <div>
    <q-input
      :label="label"
      :filled="filled"
      v-model="date"
      mask="date"
      :rules="['date']"
    >
      <q-popup-proxy
        style="text-align: center"
        ref="qDateProxy"
        transition-show="scale"
        transition-hide="scale"
      >
        <div style="text-align: center; margin: auto; position: relative">
          <q-date
            :options="options == null ? defaultOptionsFn : options"
            @input="updateValue"
            v-model="date"
          >
            <div class="row items-center justify-end">
              <q-btn v-close-popup label="Close" color="primary" flat />
            </div>
          </q-date>
        </div>
      </q-popup-proxy>
      <template v-slot:append>
        <q-icon name="event" class="cursor-pointer"> </q-icon>
      </template>
    </q-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String
    },
    label: {
      type: String,
      default: "Date"
    },
    filled: {
      type: Boolean,
      default: false
    },
    options: {
      default: null
    }
  },
  watch: {
    value: function() {
      this.date = this.value;
    }
  },
  data() {
    return {
      date: "2019/02/01"
    };
  },
  mounted() {
    this.date = this.value;
  },
  methods: {
    defaultOptionsFn() {
      return true;
    },
    updateValue() {

      this.$emit("input", this.date);
    }
  }
};
</script>
